import styled from 'styled-components';
import { ICardStyledProps } from './card.types';

export const CardStyled = styled.div<ICardStyledProps>`
  --gap: ${({ $isCompact }) => $isCompact ? '8px' : '16px'};
  padding: var(--gap);
  border-radius: 12px;
  border: 1px solid ${({ theme }) => theme.colors.gray[10]};
  background-color: ${({ theme }) => theme.colors.gray[0]};
  box-shadow: 0px 2px 4px -2px #0A265C0F;
  box-shadow: 0px 4px 8px -2px #0A265C1A;
`;
